import { render, staticRenderFns } from "./operationsPermissions.vue?vue&type=template&id=4352e23c&scoped=true"
import script from "./operationsPermissions.vue?vue&type=script&lang=js"
export * from "./operationsPermissions.vue?vue&type=script&lang=js"
import style0 from "./operationsPermissions.vue?vue&type=style&index=0&id=4352e23c&prod&lang=scss&scoped=true"
import style1 from "./operationsPermissions.vue?vue&type=style&index=1&id=4352e23c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4352e23c",
  null
  
)

export default component.exports